const apiBaseUrl =
  process.env.REACT_APP_API_BASE_URL || "https://api.cpp-additiveminds.com";

const wsHost = apiBaseUrl.replace(/^https?:\/\//, "");

const config = {
  environment: process.env.REACT_APP_ENV || "production",
  proxyGraphQLUrl: `${apiBaseUrl}/graphql`,
  serviceUrl: `${apiBaseUrl}/`,
  proxyWSGraphQLUrl: `wss://${wsHost}/graphql`,
  AxiosWSUrl: `${apiBaseUrl}/cost_calculator`,
  carbonShadowSuggestionUrl:
    "https://www.worldbank.org/en/news/press-release/2022/05/24/global-carbon-pricing-generates-record-84-billion-in-revenue",
};

export default config;
